import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexBetween, HideScrollbar } from '../../../global/commonStyle';

export const MainDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

// modal header section
export const ModalBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const SearchSection = styled.div`
  padding: var(--space-0) var(--space-16);
  width: -webkit-fill-available;
`;

export const SearchInput = styled.input`
  width: -webkit-fill-available;
  background-color: var(--background-tertiary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-4);
  padding: var(--space-4) var(--space-10);
  ${Typography.body_md}
  color: var(--text-secondary);
  :placeholder {
    color: var(--text-secondary);
  }
  &:focus-visible {
    outline: none;
  }
`;

// content section
export const ContentSection = styled.div`
  height: 200px;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: var(--space-0) var(--space-8) var(--space-6);
  ${HideScrollbar}
`;

// profile section
export const Profile = styled.label`
  padding: var(--space-8);
  ${FlexBetween}
  gap: var(--space-6);
  border-radius: var(--border-radius-8);
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-secondary);
    &.owner-tag {
      background-color: transparent;
    }
  }
`;

// left section
export const LeftSection = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;

// user Info
export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
`;

export const UserName = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;

export const UserEmail = styled.p`
  ${Typography.body_xs}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

// owner tag
export const OwnerTag = styled.p`
  padding: var(--space-3) var(--space-6);
  border-radius: var(--border-radius-6);
  background-color: var(--neutral-secondary);
  ${Typography.body_sm}
  color: var(--text-secondary);
  margin: var(--space-0);
`;
